/**
 * Action types for user login functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle user authentication.
 */

// Get SPLASH PAGES constants
export const GET_SPLASH = 'GET_SPLASH';
export const SPLASH_REQUEST_GET = 'SPLASH_REQUEST_GET';
export const SPLASH_RESPONSE_GET_SUCCESS = 'SPLASH_RESPONSE_GET_SUCCESS';
export const SPLASH_RESPONSE_GET_FAIL = 'SPLASH_RESPONSE_GET_FAIL'

export const ADD_SPLASH = 'ADD_SPLASH';
export const SPLASH_REQUEST_POST = 'SPLASH_REQUEST_POST';
export const SPLASH_RESPONSE_POST_FAIL = 'SPLASH_RESPONSE_POST_FAIL';
export const  ADD_SPLASH_RESPONSE_SUCCESS = 'ADD_SPLASH_RESPONSE_SUCCESS';

export const SPLASH_SELECTED = 'SPLASH_SELECTED';

export const SPLASH_REQUEST_PATCH = 'SPLASH_REQUEST_PATCH';
export const SPLASH_RESPONSE_PATCH_FAIL = 'SPLASH_RESPONSE_PATCH_FAIL';
export const EDIT_SPLASH_RESPONSE_SUCCESS = 'EDIT_SPLASH_RESPONSE_SUCCESS';

export const SPLASH_REQUEST_PUT = 'SPLASH_REQUEST_PUT';
export const SPLASH_RESPONSE_PUT_FAIL = 'SPLASH_RESPONSE_PUT_FAIL';
export const DELETE_SPLASH_RESPONSE_SUCCESS = 'DELETE_SPLASH_RESPONSE_SUCCESS';